import { ICELAND_COUNTRY_CODE } from '../constants/countryCodes';

export const extractCurrencyFromPrice = (price: string) => {
    if (!price) {
        return '';
    }

    const currency = price.replace(/[0-9]/g, '').replace(/[.,\s]/g, '').trim();

    return currency;
};

export function formatOptinPrice(optinPrice: number, store: string) {
    if (!optinPrice) {
        return '';
    }

    let formattedPrice = optinPrice.toString();

    if (optinPrice % 1 !== 0) {
        formattedPrice = optinPrice.toFixed(2);
    }

    if (store === ICELAND_COUNTRY_CODE) {
        formattedPrice = formattedPrice.replace('.', ',');
        formattedPrice = formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    return formattedPrice;
}

export function formatPriceAndCurrency(isSwissStore: boolean, price: string, currency: string) {
    if (!price || !currency) {
        return '';
    }

    return isSwissStore ? `${currency}${price}` : `${price} ${currency}`;
}
